import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useMemo } from 'react';
export var useOptions = function useOptions(options, formatOption) {
  return useMemo(function () {
    var isFlat = false;

    if (!options || !Array.isArray(options)) {
      return {
        isFlat: isFlat,
        internalOptions: []
      };
    }

    var internalOptions = options.map(function (option, index) {
      if (option && typeof option === 'object' && 'value' in option) {
        var formattedOption = option;

        if (formatOption) {
          formattedOption = _objectSpread(_objectSpread({}, formattedOption), {}, {
            label: formatOption(option)
          });
        }

        return formattedOption;
      }

      isFlat = true;
      return {
        label: formatOption ? formatOption(option) : option,
        value: index
      };
    });
    return {
      isFlat: isFlat,
      internalOptions: internalOptions
    };
  }, [options]);
};